export class Error {
  public constructor() {
    this.Message = '';
    this.ExceptionMessage = '';
  }
  public Message: string;
  public ExceptionMessage: string;
}
